<template v-html>
    <div v-if="programs.length <= 10">
        <div class="szurok">
            <div class="szuro" v-for="keyword in keywords">{{ keyword.value }} <!-- <i class="fas fa-times" v-on:click="delete_keyword(keyword)"></i> --></div>
            <div class="del-keyword" v-for="keyword in keywords" v-on:click="delete_keyword(keyword)">Szűrők törlése</div>
        </div>
        <div v-for="(program, index) in programs">
            <div class="row bigbox left" v-if="(index % 2 == 0)">
                <div class="col-6 program-bg" :style="{backgroundColor: program.setcolor}">
                    <p class="date"><br>{{ program.programtype }}<br><b>{{ program.monthAndDay }} | {{ program.time }}</b></p>
                    <p class="title"><a v-bind:href="program.wholeUrl" class="text-white text-uppercase" v-html="program.title">{{ program.title }}</a>
                    </p>
                    <div class="gombok text-center">
                        <a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + program.wholeUrl" class="btn"
                           target="_blank">
                            <img src="/img/facebook-circular-logo.svg" alt="Megosztás a Facebook-on"
                                 title="Megosztás a Facebook-on!" class="gombok-megosztas-feher">
                        </a>

                        <a v-bind:href="program.zoom_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-if="(program.zoom_link && program.zoom_link != 'http://' && program.zoom_link != 'https://')" target="_blank">Csatlakozz!</a>
                        <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-else-if="(program.zoom_link && program.recording_link && program.recording_link != 'http://' && program.recording_link != 'https://')" target="_blank">Nézd meg!</a>
                        <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-else-if="(program.recording_link && program.recording_link != 'http://' && program.recording_link != 'https://')" target="_blank">Nézd meg!</a>
                    </div>
                </div>
                <div class="col-6" v-bind:style="{ backgroundImage: 'url(' + program.imageSource + ')' }">
                    <div v-if="program.hasApplicationLink">
                        <a v-bind:href="program.application_link"></a>
                    </div>

                    <a v-bind:href="program.showUrl" class="clickable-area"></a>
                </div>
            </div>
            <div v-else>
                <div class="row bigbox right">
                    <div class="col-6" v-bind:style="{ backgroundImage: 'url(' + program.imageSource + ')' }">

                        <div v-if="program.hasApplicationLink">
                            <a v-bind:href="program.application_link"></a>
                        </div>

                        <a v-bind:href="program.showUrl" class="clickable-area"></a>
                    </div>
                    <div class="col-6 program-bg" :style="{backgroundColor: program.setcolor}">
                        <p class="date"><br>{{ program.programtype }}<br><b>{{ program.monthAndDay }} | {{ program.time }}</b></p>
                        <p class="title"><a v-bind:href="program.wholeUrl" class="text-white text-uppercase" v-html="program.title">{{ program.title}}</a></p>
                        <div class="gombok text-center">
                            <a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + program.wholeUrl" class="btn"
                               target="_blank">
                                <img src="/img/facebook-circular-logo.svg" alt="Megosztás a Facebook-on"
                                     title="Megosztás a Facebook-on!" class="gombok-megosztas-feher">
                            </a>
                            
                            <a v-bind:href="program.zoom_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-if="(program.zoom_link && program.zoom_link != 'http://' && program.zoom_link != 'https://')" target="_blank">Csatlakozz!</a>
                            <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-else-if="(program.zoom_link && program.recording_link && program.recording_link != 'http://' && program.zoom_link != 'https://')" target="_blank">Nézd meg!</a>
                            <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding: 12px 1.5rem 13px 1.5rem;" v-else-if="(program.recording_link && program.recording_link != 'http://' && program.recording_link != 'https://')" target="_blank">Nézd meg!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else>

        <div class="szurok">
            <div class="szuro" v-for="keyword in keywords">{{ keyword.value }} <!-- <i class="fas fa-times" v-on:click="delete_keyword(keyword)"></i> --></div>
            <div class="del-keyword" v-for="keyword in keywords" v-on:click="delete_keyword(keyword)">Szűrők törlése</div>
        </div>

        <div class="row">
            <div v-for="(program, index) in programs" class="col-md-4 mb-4">
                <div v-bind:style="{ backgroundImage: 'url(' + program.imageSourceCropped + ')'} " class="programok-hatter">
                    <a v-if="program.hasApplicationLink" v-bind:href="program.application_link"></a>
                    <a v-bind:href="program.showUrl" class="clickable-area"></a>

                </div>
                <div class="program-bg" :style="{backgroundColor: program.setcolor}">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <p class="program-vonal gasztro-vonal-hatter text-white"><span class="font-italic">{{ program.programtype }}</span>
                                    <br>{{ program.monthAndDay }} | {{ program.time }}</p>
                            </div>
                            <div class="w-100"></div>

                            <div class="col">
                                <a v-bind:href="program.showUrl" class="text-white text-uppercase"><h4><b v-html="program.title">{{ program.title }}</b>
                                </h4></a>
                            </div>
                        </div>
                        <div class="row text-uppercase gombok gombok-alaperetelmezett-szin">
                            <div class="col">
                                <p class="text-center">
                                    <a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + program.wholeUrl"
                                       class="btn" target="_blank">
                                        <img src="/img/facebook-circular-logo.svg" alt="Megosztás a Facebook-on"
                                             title="Megosztás a Facebook-on!" class="gombok-megosztas-feher">
                                    </a>
                                </p>
                            </div>
                            <div class="col">
                                <p class="text-center">
                                    <a v-bind:href="program.zoom_link" style="text-transform: uppercase; font-weight: bold; padding-top: 8px;" v-if="(program.zoom_link && program.zoom_link != 'http://' && program.zoom_link != 'https://')" target="_blank">Csatlakozz!</a>
                                    <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding-top: 8px;" v-else-if="(program.zoom_link && program.recording_link && program.recording_link != 'http://' && program.recording_link != 'https://')" target="_blank">Nézd meg!</a>
                                    <a v-bind:href="program.recording_link" style="text-transform: uppercase; font-weight: bold; padding-top: 8px;" v-else-if="(program.recording_link && program.recording_link != 'http://' && program.recording_link != 'https://')" target="_blank">Nézd meg!</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                programs: [],
                keywords: [],
                form: $('#filter-form'),
                filter_button: $('#szures-button' ),
                ajax_url: null,
            }
        },


        mounted() {

            if( location.pathname.substring(1) == 'korabbi-programok' ){
                this.ajax_url = '/ajax/programok/old';
            }
            else{
                this.ajax_url = '/ajax/programok/current';
            }

            if (history.state == null || history.state.length == 0) {

                this.ajax_filter_programs();
            } else {
                history.state.forEach(element => {
                    $('input[name="' + element.name + '"]').prop('checked', true);
                });
                this.ajax_filter_programs();
            }

        },
        methods: {
            randomColor(id) {
                const color = (max,min) => Math.floor(Math.random() * (max - min + 1) + min);
                return `rgb(${color(256,1)}, ${color(190,1)}, ${color(256,1)})`;
            },
            ajax_all_programs() {
                
                this.keywords = [];
                $.ajax({
                    url: this.ajax_url,
                    type: 'GET',
                })
                    .done(
                        resp => {
                            this.programs = resp.data;
                            $('#program_counter').html(this.programs.length + ' találat');
                        }
                    );
            },
            ajax_filter_programs() {
                this.keywords = [];
                $.ajax({
                    url: this.ajax_url,
                    type: 'POST',
                    data: this.form.serializeArray(),
                })
                    .done(
                        resp => {
                            this.programs = resp.data;
                            this.form.serializeArray().forEach(element => {
                                if (element.name != '_token') {
                                    this.keywords.push(
                                        {
                                            name: element.name,
                                            value: $('input[name="' + element.name + '"]').parent().attr('name')
                                        }
                                    );
                                }
                            });
                            $('#program_counter').html(this.programs.length + ' találat');
                        }
                    );
            },
            delete_keyword(keyword) {
                $('input[name="' + keyword.name + '"]').prop('checked', false);
                if(this.ajax_url.includes("current")){
                    window.location.href = '/programok';
                }
                else{
                    window.location.href = '/korabbi-programok';
                }
                //this.filter_button.trigger('click');
                
            }
        }
    }
</script>
